import React from 'react';
import { useLanguage } from '../LanguageContext';
import { useScrollReveal } from '../hooks/useScrollReveal';

const Tickets = () => {
  const { t } = useLanguage();
  const ref = useScrollReveal(['h2', 'p', '.tickets-card'], { stagger: 0.08 });

  return (
    <section className="tickets-section" id="tickets" ref={ref}>
      <div className="tickets-content">
        <h2>{t.tickets.title}</h2>
        {t.tickets.paragraphs.map((p, i) => <p key={i}>{p}</p>)}
        <div className="tickets-grid">
          <div className="tickets-card">
            <h3>{t.tickets.card1.title}</h3>
            <ul>{t.tickets.card1.items.map((item, i) => <li key={i}>{item}</li>)}</ul>
          </div>
          <div className="tickets-card">
            <h3>{t.tickets.card2.title}</h3>
            <ul>{t.tickets.card2.items.map((item, i) => <li key={i}>{item}</li>)}</ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Tickets;
